import { renderComponentField } from '@/shared/components/form/FormField';
import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';

export const SelectFieldDisabled = React.forwardRef(({
  onChange, value, name, placeholder, options,
}, ref) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };
  return (
    <Select
      name={name}
      value={value}
      onChange={handleChange}
      options={options}
      clearable={false}
      className="react-select"
      placeholder={placeholder}
      classNamePrefix="react-select"
      ref={ref}
      isDisabled={true}
    />
  );
});

SelectFieldDisabled.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]).isRequired,
};

SelectFieldDisabled.defaultProps = {
  placeholder: '',
  options: [],
};

export default renderComponentField(SelectFieldDisabled);
